import { render, staticRenderFns } from "./snoring-statistics.vue?vue&type=template&id=115292b4&scoped=true"
import script from "./snoring-statistics.vue?vue&type=script&lang=js"
export * from "./snoring-statistics.vue?vue&type=script&lang=js"
import style0 from "./snoring-statistics.vue?vue&type=style&index=0&id=115292b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115292b4",
  null
  
)

export default component.exports